import { isSiError } from "./types";

/**
 * The HTTP status a failure carried, or `undefined` when there is none to read — either the request
 * never reached a server, or the error is not ours.
 *
 * Callers decide what the absence means: for a request it stands for "never landed", but an assertion
 * throws status-less too, so a retry predicate must not treat the two alike.
 */
export const errorStatus = (error: unknown): number | undefined =>
    isSiError(error) ? error.context.status : undefined;
